import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { DsSgDateRangePicker } from '@sgdocs/design-system';

export const DateRangeJsonSchemaWidget = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (dates: string) => void;
}): JSX.Element => {
  const handleOnChange = (startDate: string | undefined, endDate: string | undefined): void => {
    onChange([startDate, endDate].join('#'));
  };
  let initStartDate, initEndDate;
  if (value) {
    const dates = value.split('#');
    initStartDate = dates[0] ? new Date(dates[0]) : undefined;
    initEndDate = dates[1] ? new Date(dates[1]) : undefined;
  }
  return (
    <DsSgDateRangePicker
      id={uuidv4()}
      onChange={handleOnChange}
      initStartDate={initStartDate}
      initEndDate={initEndDate}
      isPastDateEnabled={true}
      displayFormat={'dd/MM/yyyy'}
    />
  );
};
